import _ from 'underscore';
import stammdatenService from './services/stammdatenService.js';
import SystemDialogService from '../../../shared/services/systemDialogService.js';
import { erstelleMitarbeiterListe, getAktuellerZeitraum, getSelectedMitarbeiterIDs, rejectAktionBeiArchivierteMA, toggleLoader, updateProgressbar, startChunkProgress, zeigeFehlerFenster } from './util.js';
import systemNachrichtService from './services/systemNachrichtService.js';
import { berichteTypen } from './berichteTypen.js';

// create a single debounced function that forwards arguments and `this`
const gotoPageDebounce = _.debounce(function(...args) { return gotoPage.apply(this, args); }, 300);

window.myHandlers = window.myHandlers || {};
window.myVars = window.myVars || {};
window.myHandlers.getZettelHTML = getZettelHTML;
window.myHandlers.getCSV = getCSV;
window.myHandlers.getJSON = getJSON;
window.myHandlers.getXML = getXML;
window.myHandlers.importJSON = importJSON;
window.myHandlers.uploadImportJSON = uploadImportJSON;
window.myHandlers.importBewegungsdaten = importBewegungsdaten;
window.myHandlers.uploadBewegungsdatenCSV = uploadBewegungsdatenCSV;
window.myHandlers.downloadBerichtePDF = downloadBerichtePDF;
window.myHandlers.prevPage = prevPage;
window.myHandlers.nextPage = nextPage;
window.myHandlers.gotoPageDebounce = gotoPageDebounce;
window.myHandlers.uploadBerichte = uploadBerichte;
window.myHandlers.createHTMLpopUp = createHTMLpopUp;
window.myHandlers.toggleBerichtHeader = toggleBerichtHeader;

// globale variablen für die Pagination durch Berichte
let currentIndex = 0;
let htmlArray = [];
const betriebsberichte = [berichteTypen.Personalkosten, berichteTypen.Stundenbereiche, berichteTypen.Bereichsauswertung, berichteTypen.Einsatzortauswertung, berichteTypen.BgnListe, berichteTypen.Erstattungsliste];

async function getZettelHTML(zettelType) {
    if (rejectAktionBeiArchivierteMA()) {
		return;
    }
    // active item auswahl
    document.querySelectorAll('.report-item-active').forEach((elem) => elem.classList.remove('report-item-active'));
    document.getElementById(zettelType).classList.add('report-item-active');
    let aktuellerZeitraum = getAktuellerZeitraum();
	// sammle alle angehakten MitarbeiterIDs
	const maList = getSelectedMitarbeiterIDs();
	if (!betriebsberichte.includes(zettelType.split('-')[0]) && maList.length < 1) {
		await SystemDialogService.instance.displayAsync('kein-ma-alert-dialog');
		return;
	}
    // Jahresauswahl bei bestimmten Berichten
    if (['bgn-html'].includes(zettelType)) {
        document.getElementById('berichte-jahr-stammdaten').value = window.myVars.aktuellesMonatsDatum.format('YYYY');
        const result = await SystemDialogService.instance.displayAsync('berichte-jahr-stammdaten-dialog');
        if (!result.success) return;
        aktuellerZeitraum = result.data.Abrechnungsjahr;
    }
    let result = [];
    // Bei Berichten, wo es zu sehr vielen Seiten kommen kann, bieten sich chunks an zu verbesserten ladezeit
    if (['lohnabrechnung-html', 'stundenzettel-html', 'stundenauswertung-html'].includes(zettelType)) {
        const progressTitle = 'Laden von Berichten';
        const maListChunks = _.chunk(maList, 25);
        let progressCounter = 0;
        updateProgressbar(progressCounter, maList.length, progressTitle);
        for (const list of maListChunks) {
            const stopProgress = startChunkProgress(progressCounter, list.length, maList.length, progressTitle, undefined, 250);
            const chunkResult = await stammdatenService.postBerichteMA(list, aktuellerZeitraum, zettelType.split('-')[0]);
            result = _.union(result, chunkResult);
            if (result && result.length > 0) {
                showReportHTML(result, progressCounter == 1);
            }
            progressCounter += list.length;
            stopProgress(progressCounter);
        }
    } else {
        window.myHandlers.toggleLoader();
        result = await stammdatenService.postBerichteMA(maList, aktuellerZeitraum, zettelType.split('-')[0]);
        window.myHandlers.toggleLoader();
        if (result && result.length > 0) {
           showReportHTML(result);
        } 
    }
    
}

async function getCSV(csvType) {
    if (rejectAktionBeiArchivierteMA()) {
		return;
    }
    // active item auswahl
    document.querySelectorAll('.report-item-active').forEach((elem) => elem.classList.remove('report-item-active'));
    document.getElementById(csvType).classList.add('report-item-active');
    let aktuellerZeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD');
    if (csvType == 'stammdaten') {
        document.getElementById('berichte-monat-stammdaten').value = window.myVars.aktuellesMonatsDatum.format('YYYY-MM');
        const result = await SystemDialogService.instance.displayAsync('berichte-monat-stammdaten-dialog');
        if (!result.success) return;
        aktuellerZeitraum = result.data.Abrechnungsmonat;
    }
    if (csvType == 'rueckstellungen-csv') {
        document.getElementById('berichte-jahr-stammdaten').value = window.myVars.aktuellesMonatsDatum.format('YYYY');
        const result = await SystemDialogService.instance.displayAsync('berichte-jahr-stammdaten-dialog');
        if (!result.success) return;
        aktuellerZeitraum = result.data.Abrechnungsjahr;
    }
    // wir nehmen alle angehakten Mitarbeiter, ansonsten den aktuell ausgewählten Mitarbeiter.
    const maList = getSelectedMitarbeiterIDs();
	if (maList.length < 1) {
		await SystemDialogService.instance.displayAsync('kein-ma-alert-dialog');
		return;
	}
    await stammdatenService.postBerichteCSV(maList, aktuellerZeitraum, csvType.split('-')[0]);
}

async function getJSON(jsonType) {
    // active item auswahl
    const aktuellerZeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD');
    document.querySelectorAll('.report-item-active').forEach((elem) => elem.classList.remove('report-item-active'));
    document.getElementById(jsonType).classList.add('report-item-active');
    // wir nehmen alle angehakten Mitarbeiter, ansonsten den aktuell ausgewählten Mitarbeiter.
    const maList = getSelectedMitarbeiterIDs();
	if (maList.length < 1) {
		await SystemDialogService.instance.displayAsync('kein-ma-alert-dialog');
		return;
	}
    await stammdatenService.postBerichteJSON(maList, aktuellerZeitraum, jsonType.split('-')[0]);
}

async function getXML(xmlType) {
    if (rejectAktionBeiArchivierteMA()) {
		return;
    }
    // active item auswahl
    document.querySelectorAll('.report-item-active').forEach((elem) => elem.classList.remove('report-item-active'));
    document.getElementById(xmlType).classList.add('report-item-active');
    const aktuellerZeitraum = window.myVars.aktuellesMonatsDatum.format('YYYY-MM-DD');
    // wir nehmen alle angehakten Mitarbeiter, ansonsten den aktuell ausgewählten Mitarbeiter.
    const maList = getSelectedMitarbeiterIDs();
	if (maList.length < 1) {
		await SystemDialogService.instance.displayAsync('kein-ma-alert-dialog');
		return;
	}
    await stammdatenService.postBerichteXML(maList, aktuellerZeitraum, xmlType.split('-')[0], stammdatenService.aktuelleBetriebsstaette);
}

async function importJSON(jsonType) {
    // active item auswahl
    document.querySelectorAll('.report-item-active').forEach((elem) => elem.classList.remove('report-item-active'));
    document.getElementById(jsonType).classList.add('report-item-active');
    const input = document.getElementById('json-import-input');
    input.click();
}

async function uploadImportJSON(thisElement) {
    const inputForm = thisElement.closest('form');
    const file = new FormData(inputForm);
    const allowedDataFormats = ['application/json'];
    if (!allowedDataFormats.includes(file.get('file-upload').type)) {
        systemNachrichtService.zeigeKleineNachricht('Nur .json Dateien sind erlaubt!');
        thisElement.value = '';
        return;
    }
    const betriebID = document.getElementById('menu-betriebsstaette').value;
    if (!betriebID) {
        systemNachrichtService.zeigeKleineNachricht('Bitte wählen Sie eine Betriebsstätte aus!');
        thisElement.value = '';
        return;
    }
    file.append('BetriebsstaetteID', betriebID);
    await stammdatenService.importMitarbeiterStammdatenJSON(file, betriebID);
    thisElement.value = '';
    await erstelleMitarbeiterListe(betriebID);
}

async function importBewegungsdaten(importType) {
    // active item auswahl
    document.querySelectorAll('.report-item-active').forEach((elem) => elem.classList.remove('report-item-active'));
    document.getElementById(importType).classList.add('report-item-active');
    document.getElementById('bewegungsdaten-import-input').click();
}

async function uploadBewegungsdatenCSV(thisElement) {
    const inputForm = thisElement.closest('form');
    const file = new FormData(inputForm);
    const uploadedFile = file.get('file-upload');
    const fileName = uploadedFile?.name?.toLowerCase() ?? '';
    if (!(fileName.endsWith('.csv') || fileName.endsWith('.txt'))) {
        systemNachrichtService.zeigeKleineNachricht('Nur .csv Dateien sind erlaubt!');
        thisElement.value = '';
        return;
    }
    const result = await stammdatenService.importBewegungsdatenCSV(file);
    thisElement.value = '';
    if (result?.errors?.length > 0) {
        zeigeFehlerFenster(`Fehler beim Bewegungsdaten Import (${result.errors.length})`, { liste: result.errors });
        return;
    }
    // Mitarbeiterliste neu laden, damit die importierten Lohnarten/Umsätze sichtbar sind
    const betriebID = document.getElementById('menu-betriebsstaette').value;
    if (betriebID) {
        await erstelleMitarbeiterListe(betriebID);
    }
}

function showReportHTML(reports, resetIndex = true) {
    htmlArray = reports;
    const pagination = document.getElementById('report-pagination');
    // aktuelle Seitenzahl
    currentIndex = resetIndex ? 0 : currentIndex;
    if (currentIndex >= reports.length) currentIndex = 0;
    // Zeige den Lohnzettel im HTML Viewer in der Oberfläche an
    const reportarea = document.getElementById('reportarea');
    reportarea.innerHTML = reports[currentIndex];
    pagination.querySelector('#report-page-start').value = currentIndex + 1;
    pagination.querySelector('#report-page-end').innerText = reports.length;
    pagination.classList.remove('hidden');
}

function prevPage() {
    const reportarea = document.getElementById('reportarea');
    currentIndex = currentIndex - 1 < 0 ? 0 : currentIndex - 1;
    reportarea.innerHTML = htmlArray[currentIndex];
    document.querySelector('#report-page-start').value = currentIndex + 1;
}

function nextPage() {
    const reportarea = document.getElementById('reportarea');
    currentIndex = currentIndex + 1 >= htmlArray.length ? htmlArray.length - 1 : currentIndex + 1;
    reportarea.innerHTML = htmlArray[currentIndex];
    document.querySelector('#report-page-start').value = currentIndex + 1;
}

function gotoPage(thisElement) {
    if (!thisElement) return;
    const input = parseInt(thisElement.value, 10);
    if (!input || input < 1 || input > htmlArray.length) {
        thisElement.value = currentIndex + 1;
        return;
    }
    const reportarea = document.getElementById('reportarea');
    currentIndex = input - 1;
    reportarea.innerHTML = htmlArray[currentIndex];
}

/**
 * Lädt die Bericht Oberfläche und richtet ggfs. die Event Handlers ein
 * @param {boolean} refreshEventHandlers bestimmt, ob die Event Handler eingespielt werden sollen.
 * Nur sinnvoll wenn die Bericht Seite zum ersten Mal geladen wird, sonst enstehen doppelte EventHandler Aktionen.
 */
async function ladeBerichteMA(refreshEventHandlers = false, monatswechsel = false) {
    const aktuellerMA = stammdatenService.aktuellerMitarbeiter;
    const auswahl = document.querySelector('.report-item-active')?.id;
    const type = auswahl ? auswahl.split('-')[1] : '';
    const berichtAuswahl = auswahl ? auswahl.split('-')[0] : '';
    if (_.isEmpty(aktuellerMA) && auswahl && !betriebsberichte.includes(berichtAuswahl)) {
        return;
    } else if (!monatswechsel && !_.isEmpty(aktuellerMA) && betriebsberichte.includes(berichtAuswahl)) {
        // Betriebsberichte nicht bei MA auswahl laden...
        return;
    };
    
    const pagination = document.getElementById('report-pagination');
    pagination.classList.add('hidden');
    const reportarea = document.getElementById('reportarea');
    // event listener für pagination mit Pfeiltasten
    if (refreshEventHandlers) {
        reportarea.addEventListener('keyup', (event) => {
            if (event.key === 'ArrowLeft') {
                prevPage();
            }
            if (event.key === 'ArrowRight') {
                nextPage();
            }
        });        
        const uploadHTML = document.getElementById('bericht-upload-zone');
        addDragAndDropEvents(uploadHTML);
    }
    currentIndex = 0;
    htmlArray = [];
    const inputKW = document.getElementById('report-kw');
    inputKW.value = window.myVars.aktuellesMonatsDatum.add(14, 'hours').isoWeek(); // isoWeek() nimmt local TZ: für Zeitzonen Behandlung addieren wir 14h

    
    reportarea.innerHTML = '';
    switch (type) {
        case 'html':
            await getZettelHTML(auswahl);
            break;
        case 'csv':
            await getCSV(auswahl);
            break;
        case 'xml':
            await getXML(auswahl);
            break;
        default:
            // Nur Lohnabrechnung automatisch laden, wenn es ein Mitarbeiter ist, sonst kommen wir in unnötige Ladezeiten
            const checkedMA = getSelectedMitarbeiterIDs();
            if (checkedMA.length === 1 && !window.myVars.HideMod) {
                await getZettelHTML('lohnabrechnung-html');
                document.getElementById('lohnabrechnung-html').classList.add('.report-item-active');
            }
            break;
    }
}

async function downloadBerichtePDF() {
    // zettelType auswahl
    const auswahl = document.querySelector('.report-item-active').id;
    const zettelType = auswahl.split('-')[0];
    const aktuellerZeitraum = getAktuellerZeitraum();
	const maList = getSelectedMitarbeiterIDs();
    if (!betriebsberichte.includes(zettelType) && _.isEmpty(maList)) {
        await SystemDialogService.instance.displayAsync('kein-ma-alert-dialog');
        return;
    }
    // Bei Berichten, wo es zu sehr vielen Seiten kommen kann, bieten sich chunks an zu verbesserten ladezeit
    if (['lohnabrechnung', 'stundenzettel', 'stundenauswertung'].includes(zettelType)) {
        const progressTitle = 'Laden von Berichten';
        const progressInfo = 'Download kann zu mehreren Dateien führen.';
        const maListChunks = _.chunk(maList, 25);
        let progressCounter = 0;
        updateProgressbar(progressCounter, maList.length, progressTitle, progressInfo);
        for (const list of maListChunks) {
            const stopProgress = startChunkProgress(progressCounter, list.length, maList.length, progressTitle, progressInfo, 2000);
            await stammdatenService.downloadBerichteMA(list, aktuellerZeitraum, zettelType);
            progressCounter += list.length;
            stopProgress(progressCounter);
        }
    } else {
        await stammdatenService.downloadBerichteMA(maList, aktuellerZeitraum, zettelType);
    }
}


/**
 * Lädt die Berichte per fetch und formData hoch
 * @param {HTMLElement} thisElement file input Element
 */
async function uploadBerichte(thisElement) {
    const inputForm = thisElement.closest('form');
    const file = new FormData(inputForm);
    const allowedDataFormats = ['application/pdf'];
    if (!allowedDataFormats.includes(file.get('file-upload').type)) {
        systemNachrichtService.zeigeKleineNachricht('Nur .pdf Dateien sind erlaubt!');
        thisElement.value = '';
        return;
    }
    const betriebID = document.getElementById('menu-betriebsstaette').value;
    if (!betriebID) {
        systemNachrichtService.zeigeKleineNachricht('Bitte wählen Sie eine Betriebsstätte aus!');
        thisElement.value = '';
        return;
    }
    const docType = document.getElementById('bericht-upload-select')?.value;
    if (docType === 'Lohnabrechnung') {
        await lohnabrechnungUpload(file, thisElement, betriebID);
    } else {
        await allgemeinerBerichtUpload(file, thisElement, betriebID, docType);
    }
    
}

async function lohnabrechnungUpload(file, fileInputHTML, betriebID) {
    // Standardmäßig aktuellen Zeitraum wählen...
    document.getElementById('berichte-monat-dialog').value = document.getElementById('monats-auswahl').value;
    const input = await SystemDialogService.instance.displayAsync('berichte-probeabrechnung-dialog');
    if (!input.success) {
        fileInputHTML.value = '';
        return;
    }
    file.append('BetriebsstaetteID', betriebID);
    file.append('Zeitraum', `${input.data.Zeitraum}-01`);
    file.append('Probeabrechnung', input.data.IstProbe);
    try {
        toggleLoader();
        const response = await fetch('/neolohn/api/berichte', {
            method: 'POST',
            body: file
        });
        if (!response.ok) {
            const msg = await response.text();
            systemNachrichtService.zeigeKleineNachricht(msg);
            throw new Error('HTTP Error Status: ', response.status);
        }
        const result = await response.json();
        systemNachrichtService.zeigeKleineNachricht('Upload erfolgerich!', 1);
        toggleLoader();
        await showAbweichungList(result);
        await erstelleMitarbeiterListe(betriebID);
        fileInputHTML.value = '';
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Upload fehlgeschlagen!', -1);
        fileInputHTML.value = '';
        toggleLoader();
    }
}

async function allgemeinerBerichtUpload(file, fileInputHTML, betriebID, docType) {
    file.append('BetriebsstaetteID', betriebID);
    // Standardmäßig aktuellen Zeitraum wählen...
    document.getElementById('berichte-upload-jahr').value = window.myVars.aktuellesMonatsDatum.format('YYYY-MM');
    const input = await SystemDialogService.instance.displayAsync('berichte-upload-dialog');
    if (!input.success) {
        fileInputHTML.value = '';
        return;
    }
    file.append('Zeitraum', `${input.data.Abrechnungsjahr}`);
    try {
        toggleLoader();
        const response = await fetch(`/neolohn/api/berichte/${docType}`, {
            method: 'POST',
            body: file
        });
        if (!response.ok) {
            const msg = await response.text();
            systemNachrichtService.zeigeKleineNachricht(msg);
            throw new Error('HTTP Error Status: ', response.status);
        }
        const result = await response.json();
        systemNachrichtService.zeigeKleineNachricht('Upload erfolgerich!', 1);
        toggleLoader();
        await showAbweichungList(result);
        fileInputHTML.value = '';
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Upload fehlgeschlagen!', -1);
        fileInputHTML.value = '';
        toggleLoader();
    }
}

async function showAbweichungList(liste) {
    const abweichungen = liste.filter((ma) => ma.AbweichungLohnabrechnung);
    const notFound = liste.filter((ma) => !ma.MatchFound);
    const rvNummern = liste.filter((ma) => ma.RVNummer);
    const steuerNummern = liste.filter((ma) => ma.SteuerID);
    if (notFound.length <= 0 && abweichungen.length <= 0) {
        systemNachrichtService.zeigeKleineNachricht('Keine Abweichungen gefunden!', 1);
        return;
    }
    const body = document.getElementById('abweichung-liste-alert-body');
    if (abweichungen.length > 0) {
        const h4 = document.createElement('h4');
        h4.innerText = 'Abweichungen zu neolohn:';
        body.appendChild(h4);
        const p = document.createElement('p');
        p.innerHTML = '<span>Es liegen Abweichungen in der Lohnabrechnung vor, bitte überprüfen Sie die Mitarbeiter Liste nach diesem Symbol: <i class="bi bi-question-circle-fill"></i></span>';
        body.appendChild(p);
        const p2 = document.createElement('p');
        p2.innerText = 'Tipp: Benutzen Sie den Monatsinfo Filter: "abweichende Lohnabrechnung", um alle Mitarbeiter mit Abweichungen anzuzeigen.';
        body.appendChild(p2);
    }
    if (notFound.length > 0 && rvNummern.length > 0 || notFound.length > 0 && (rvNummern.length <= 0 && steuerNummern <= 0)) {
        const h4 = document.createElement('h4');
        h4.innerText = 'Unzuordenbare RV-Nummern:';
        body.appendChild(h4);
        const p = document.createElement('p');
        p.innerText = 'Folgende RV-Nummern aus dem Upload konnten keinem Mitarbeiter zugeordnet werden. \nBitte gehen Sie sicher, dass alle Mitarbeiter eine RV-Nummer eingetragen haben.';
        body.appendChild(p);
        const listHTML = document.createElement('ul');
        notFound.forEach((item) => {
            const li = document.createElement('li');
            li.innerText = `${item.RVNummer ? item.RVNummer : `Nicht gefunden: ${item.errors.join(', ')}`} ${item.SeitePDF != undefined ? `(Seite ${item.SeitePDF})` : '' }`;
            listHTML.appendChild(li);
        });
        body.appendChild(listHTML);
    }
    if (notFound.length > 0 && steuerNummern.length > 0) {
        const h4 = document.createElement('h4');
        h4.innerText = 'Unzuordenbare Steuer-IDs:';
        body.appendChild(h4);
        const p = document.createElement('p');
        p.innerText = 'Folgende Steuer-IDs aus dem Upload konnten keinem Mitarbeiter zugeordnet werden. \nBitte gehen Sie sicher, dass alle Mitarbeiter eine Steuer-IDs eingetragen haben.';
        body.appendChild(p);
        const listHTML = document.createElement('ul');
        notFound.forEach((item) => {
            const li = document.createElement('li');
            li.innerText = `${item.SteuerID ? item.SteuerID : `Nicht gefunden: ${item.errors.join(', ')}`} ${item.SeitePDF != undefined ? `(Seite ${item.SeitePDF})` : '' }`;
            listHTML.appendChild(li);
        });
        body.appendChild(listHTML);
    }
    await SystemDialogService.instance.displayAsync('abweichung-liste-alert-dialog');
    body.innerHTML = '';
}

function addDragAndDropEvents(uploadZone) {
    const start = ['dragover', 'dragenter'];
    const end = ['dragleave', 'dragend'];
    start.forEach((dragEvent) => {
        uploadZone.addEventListener(dragEvent, (event) => {
            event.preventDefault();
            uploadZone.classList.add('drop-zone-dragover');
        });
    });
    end.forEach((dragEvent) => {
        uploadZone.addEventListener(dragEvent, (event) => {
            event.preventDefault();
            uploadZone.classList.remove('drop-zone-dragover');
        });
    });

    uploadZone.addEventListener('drop', async (e) => {
        e.preventDefault();
        const input = uploadZone.querySelector('#input-file-upload');
        input.files = e.dataTransfer.files;
        uploadZone.classList.remove('drop-zone-dragover');
        await uploadBerichte(input);
    });
}

/**
 * Öffnet den aktuellen HTML Bericht in einem neuem popup
 */
function createHTMLpopUp() {
    if (!_.isEmpty(htmlArray)) {
        const getSelectedReport = document.body.querySelector('.report-item-active');
        // Porträit oder Querformat
        const landscape = ['lohnabrechnung', 'Stundenzettel'].includes(getSelectedReport.id) ? 'width=750px, height=1080px,' : 'width=1100px, height=750px,';
        if (window.myVars.popUpBericht) {
            window.myVars.popUpBericht.close();
        }
        window.myVars.popUpBericht = window.open('about:blank', 'popup', `${landscape} toolbar=no, menubar=no, resizable=yes`);
        window.myVars.popUpBericht.document.write(htmlArray[currentIndex]);
        window.myVars.popUpBericht.document.title = getSelectedReport.innerText;
        window.myVars.popUpBericht.focus();
    }
}

/**
 * Klappt Bericht Kategorien ein/aus
 * @param {*} thisElement HTML Header
 */
function toggleBerichtHeader(thisElement) {
    thisElement.classList.toggle('closed-header');
    let tmpSibling = thisElement.nextElementSibling;
    while(tmpSibling && tmpSibling.classList.contains('schriftverkehr-liste-item')) {
        tmpSibling.classList.toggle('hidden');
        tmpSibling = tmpSibling.nextElementSibling;
    }
}

export { ladeBerichteMA, getZettelHTML };
